import PropTypes from "prop-types";
import VuiBox from "components/VuiBox";
import { useVisionUIController, setLayout } from "context";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { useEffect } from "react";
import VuiTypography from "components/VuiTypography";
import bgAdmin from "assets/images/backgrounds/auth-background.svg";

export function AuthLayout({
  title,
  logo,
  children,
}) {
  const [, dispatch] = useVisionUIController();
  const { pathname } = useLocation();

  useEffect(() => {
    setLayout(dispatch, 'page');
  }, [pathname]);

  return (
    <VuiBox
      alignItems="center"
      width="100%"
      height="100vh"
      sx={({ breakpoints }) => ({
        overflowX: "hidden",
        position: "relative",
        display: "flex",
        justifyContent: "space-around",
        flexWrap: "wrap",
        background: `url(${bgAdmin})`,
        backgroundSize: "cover",
        [breakpoints.down("md")]: {
          background: 'unset',
          height: "unset",
          paddingTop: "60px",
          gap: "80px",
        },
      })}
    >
      <VuiBox sx={({ breakpoints }) => ({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        maxWidth: "50%",
        [breakpoints.down("md")]: {
          maxWidth: "100%",
        },
        [breakpoints.only("md")]: {
          maxWidth: "100%",
        },
      })}>
        <VuiBox
          sx={({ breakpoints }) => ({
            [breakpoints.down("md")]: {
              width: "182px",
            },
            [breakpoints.only("md")]: {
              width: "250px",
            },
            [breakpoints.up("lg")]: {
              width: "387px",
            },
          })}>
          <VuiBox
            component="img"
            src={logo}
            mb="8px"
            width="100%"
          />
        </VuiBox>
        <VuiTypography
          sx={({ breakpoints, palette }) => ({
            color: palette.text.focus,
            [breakpoints.down("md")]: {
              fontSize: "20px",
            },
            [breakpoints.only("md")]: {
              fontSize: "20px",
            },
            [breakpoints.up("md")]: {
              fontSize: "25px",
              textAlign: "center",
              letterSpacing: "0.2rem",
            },
          })}
        >{title}</VuiTypography>
      </VuiBox>
      <VuiBox sx={({ breakpoints }) => ({
        [breakpoints.down("md")]: {
          width: "100%",
        },
      })}>
        {children}
      </VuiBox>
    </VuiBox >
  );
}

// Setting default values for the props of CoverLayout
AuthLayout.defaultProps = {
  header: "",
  title: "",
  description: "",
  color: "info",
  top: 20,
};

// Typechecking props for the CoverLayout
AuthLayout.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
    "light",
  ]),
  header: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string.isRequired,
  top: PropTypes.number,
  children: PropTypes.node.isRequired,
};
